import { Button } from '@chronosphereio/chrono-ui';
import {
  AnchorHTMLAttributes,
  ComponentProps,
  DetailedHTMLProps,
  ElementType,
  PropsWithChildren,
  ReactNode,
} from 'react';
import { useLinkTypeByUrl } from './ContextLinkTypesProvider';

type AnchorProps = DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>;

export const LinkDecorator = (props: AnchorProps) => {
  const url = props.href || '';
  const linkType = useLinkTypeByUrl(url);

  if (linkType.Decorator) {
    return <linkType.Decorator {...props} href={url} Component={DefaultLinkDecorator} />;
  }

  return <DefaultLinkDecorator href={props.href}>{props.children}</DefaultLinkDecorator>;
};

export const LinkDecoratorClassName = 'LinkDecorator';

type OtherProps<T> = T extends ElementType ? ComponentProps<T> : { href?: string };
type LinkDecoratorProps<T> = { component?: T; icon?: ReactNode } & OtherProps<T>;

export function DefaultLinkDecorator<T>({
  component,
  icon,
  children,
  ...props
}: PropsWithChildren<LinkDecoratorProps<T>>) {
  const componentType = component || 'a';

  return (
    <Button
      className={LinkDecoratorClassName}
      size="small"
      variant="secondary"
      sx={{
        '.MuiButton-startIcon': {
          color: 'status.default.highContrast',
        },
      }}
      component={componentType}
      StartIcon={icon}
      {...props}
    >
      {children}
    </Button>
  );
}

export type LinkButtonComponent = typeof DefaultLinkDecorator;
